import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ProfileForm } from "@/pages/doctor/DoctorProfile";
import { PartnerProfile } from "@/pages/partner/PartnerPages";
import { PageHead } from "@/components/common";

export function AdminDoctorEdit() {
  const { id } = useParams();
  return (
    <div data-testid="admin-doctor-edit-page">
      <Link to="/admin/doctors" className="text-sm muted inline-flex items-center gap-1 mb-4"><ArrowLeft className="h-4 w-4" />Doctors</Link>
      <PageHead eyebrow="Editing on behalf of the doctor" title="Doctor profile" sub="All fields are editable by admins. Changes are audit-logged." />
      <ProfileForm base={`/admin/doctors/${id}`} admin />
    </div>
  );
}

export function AdminPartnerEdit() {
  const { id } = useParams();
  return (
    <div data-testid="admin-partner-edit-page">
      <Link to="/admin/partners" className="text-sm muted inline-flex items-center gap-1 mb-4"><ArrowLeft className="h-4 w-4" />Suvidha partners</Link>
      <PartnerProfile base={`/admin/partners/${id}`} admin />
    </div>
  );
}
